import axios from 'axios'
import apiConfiguration from '../utilities/api/apiConfiguration'
import 'url-search-params-polyfill'

// import availability actions
import fetchAvailabilityData from './fetchAvailability'
import fetchAccorLoginToken from './fetchAccorLoginToken'

//import content actions
import fetchHotelContentFeeds from './fetchHotelContentFeeds'

import generateUuid from '../utilities/api/generateUuid'
import getCookie from '../utilities/session/getCookie'
import setCookie from '../utilities/session/setCookie'

// GA events handler
import { addGTMContainer } from '../utilities/analytics/addGTMContainer'
import triggerCustomGaEvent from '../utilities/analytics/triggerCustomGaEvent'

import yn from 'yn'
import _ from 'lodash'
import { fetchCendynLoginToken } from './fetchCendynLoginToken'

// config actions
export const FETCH_CONFIG_BEGIN   = 'FETCH_CONFIG_BEGIN'
export const FETCH_CONFIG_SUCCESS = 'FETCH_CONFIG_SUCCESS'
export const FETCH_CONFIG_FAILURE = 'FETCH_CONFIG_FAILURE'

export const fetchConfigBegin = language => ({
	type: FETCH_CONFIG_BEGIN,
	payload: language
})

export const fetchConfigSuccess = config => ({
	type: FETCH_CONFIG_SUCCESS,
	payload: config
})

export const fetchConfigError = error => ({
	type: FETCH_CONFIG_FAILURE,
	payload: { error }
})

// Handle initial config request
export default function fetchConfiguration() {
	return dispatch => {
		let sessionId = generateUuid()

		if (
			getCookie('flowSessionId') &&
			getCookie('flowSessionId') === '' &&
			yn(process.env.REACT_APP_COMPONENT_ENABLE_XHR_SESSION_ID)
		) {
			setCookie('flowSessionId', sessionId, 1)
		} else if (!getCookie('flowSessionId')) {
			setCookie('flowSessionId', sessionId, 1)
		}

		// Import Query string & Parse URL
		const queryString = require('query-string')
		const urlQuery = queryString.parse(window.location.search)

		if (urlQuery.hotelCode) {
			addGTMContainer(urlQuery.hotelCode)
		}

		// Set default lang
		let currentLanguage = 'en'

		// Use lang query param
		if (urlQuery.primaryLangId) {
			currentLanguage = urlQuery.primaryLangId
		}

		// URL Params
		let urlParams = {
			primaryLangId: currentLanguage,
			clientId: process.env.REACT_APP_FLOW_SBE_CLIENT_ID || "ennismore",
		}

		console.log('urlQuery.hotelCode', urlQuery.hotelCode)
		let currentEndpointUrl = process.env.REACT_APP_FLOW_ENDPOINT_URL;

		// Fetch Query string method
		const fetchQuery = new URLSearchParams()

		// Loop urlParams for undefined values & remove
		for (let key in urlParams) {
			if (typeof urlParams[key] === "undefined") continue
			fetchQuery.append(key, urlParams[key])
		}

		// Base API path
		console.log('currentEndpointUrl', currentEndpointUrl)
		let apiBase = currentEndpointUrl + '/api/config?'

		// Combine API URL & formatted urlParams
		const fetchResult = apiBase + fetchQuery.toString()

		dispatch(fetchConfigBegin(currentLanguage))

		return axios.get(fetchResult, apiConfiguration())
			.then((response) => {
				let groupedConfigData = {}

				// Narrow results to hydra member see OTA spec for details
				const configuration = response.data['hydra:member'].map(config => {
 				  return config
 			  })

				// Key config by ID type
				for (let configKeys in configuration){
					groupedConfigData[configuration[configKeys].id] = configuration[configKeys]
				}

				// Dispatch initial GA events
				triggerCustomGaEvent('analytics-initialPageLoad', window.location.href)
				triggerCustomGaEvent('analytics-userSessionId', sessionId)

				dispatch(fetchConfigSuccess(groupedConfigData))

				return configuration
			})
			.then(() => {
				dispatch(fetchHotelContentFeeds())

				const currentTokenData = getCookie('accorAuthToken')
				const decodedTokenData = currentTokenData ? atob(currentTokenData) : null
				const parsedTokenDate = decodedTokenData ? JSON.parse(decodedTokenData) : null
				const refreshToken = _.get(parsedTokenDate, 'refresh_token', null)

				// setTimeout(function() {
				if (
					yn(process.env.REACT_APP_COMPONENT_ENABLE_PROFILE_SERVICES) &&
					process.env.REACT_APP_CRM_PROVIDER === 'accor' &&
					urlQuery.code
				) {
					document.cookie = `accorAuthCode=${urlQuery.code}; max-age=3600; path=/`
					dispatch(fetchAccorLoginToken(urlQuery.code, refreshToken))
				} else if (
					yn(process.env.REACT_APP_COMPONENT_ENABLE_PROFILE_SERVICES) &&
					process.env.REACT_APP_CRM_PROVIDER === 'accor' &&
					getCookie('accorAuthCode') &&
					getCookie('accorAuthCode') !== '' &&
					refreshToken
				) {
					const authCode = getCookie('accorAuthCode')
					dispatch(fetchAccorLoginToken(authCode, refreshToken))
				} else if (
					yn(process.env.REACT_APP_COMPONENT_ENABLE_PROFILE_SERVICES) &&
					process.env.REACT_APP_CRM_PROVIDER === 'cendyn' &&
					urlQuery.code &&
					urlQuery.state
				) {
					dispatch(fetchCendynLoginToken(urlQuery.code, urlQuery.state))
				} else {
					dispatch(fetchAvailabilityData(0))
				}
				// }, 2000)
			})
			.catch(error => dispatch(fetchConfigError(error)))
	}
}


// WEBPACK FOOTER //
// ./src/actions/fetchConfiguration.js